"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-1079.108 -170.741)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1079.108 170.741)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1091.107,194.739a12,12,0,1,1,12-12A12.012,12.012,0,0,1,1091.107,194.739Zm0-23.038a11.039,11.039,0,1,0,11.039,11.039A11.052,11.052,0,0,0,1091.107,171.7Z",
    transform: "translate(-1079.108 -170.741)"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1082.185 178.1)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#93c01f ",
    d: "M1100.465,184.062a.586.586,0,0,0-.831,0l-3.6,3.6-.761-.762a.588.588,0,1,0-.832.832l1.178,1.177a.586.586,0,0,0,.831,0l4.012-4.012A.586.586,0,0,0,1100.465,184.062Z",
    transform: "translate(-1082.792 -178.627)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#93c01f ",
    d: "M1087.544,188.857A5.226,5.226,0,0,1,1086,178.638h0a5.245,5.245,0,0,1,5.661,1.779l5.809-1.8a.59.59,0,0,1,.447.041l1.582.835a.587.587,0,0,1,.246.795l-.835,1.582a.587.587,0,0,1-.346.288l-.975.3-.442.839a.591.591,0,0,1-.795.246l-.839-.443-.34.106-.444.839a.591.591,0,0,1-.795.246l-.838-.443-.339.1a5.226,5.226,0,0,1-5.208,4.9Zm-1.2-9.1a4.05,4.05,0,1,0,5.242,3.773.588.588,0,0,1,.415-.575l.976-.3a.587.587,0,0,1,.448.041l.534.282.282-.535a.592.592,0,0,1,.347-.287l.805-.249a.581.581,0,0,1,.448.041l.534.281.281-.535a.591.591,0,0,1,.348-.287l.975-.3.446-.847-.846-.446-5.981,1.85a.586.586,0,0,1-.666-.242,4.065,4.065,0,0,0-4.589-1.664Z",
    transform: "translate(-1082.313 -178.407)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#93c01f ",
    d: "M1086,186.144a1.858,1.858,0,1,1,.549-.083A1.864,1.864,0,0,1,1086,186.144Zm0-2.53a.684.684,0,0,0-.2.03.676.676,0,1,0,.847.447A.68.68,0,0,0,1086,183.614Z",
    transform: "translate(-1082.387 -178.569)"
  }))));
};

exports["default"] = _default;